module.exports = __webpack_public_path__ + "img/terms-and-conditions.c699b52.png";